import React from 'react';
import { Mail, Linkedin, Phone } from 'lucide-react';

const ContactInfo = () => {
  return (
    <div className="contact-info reveal">
      <div className="section-label">Hire a Performance Marketing Consultant</div>
      <h2 className="section-title">Ready to Scale Your Revenue? Let's Talk.</h2>
      <div className="title-underline"></div>
      
      <p className="contact-description">
        If your business needs a growth marketing consultant to fix attribution, scale paid media profitably, or build AI-driven marketing systems — I can help. Book a strategy call to discuss your growth challenges.
      </p>
      
      <div className="contact-links">
        <a href="https://www.linkedin.com/in/sanjibroy" target="_blank" rel="noopener noreferrer" className="contact-link">
          <Linkedin className="contact-icon" size={20} />
          <span>linkedin.com/in/sanjibroy</span>
        </a>
        
        <a href="mailto:roy.san007@gmail.com" className="contact-link">
          <Mail className="contact-icon" size={20} />
          <span>roy.san007@gmail.com</span>
        </a>
        
        <a href="tel:+919903472976" className="contact-link">
          <Phone className="contact-icon" size={20} />
          <span>+91 9903472976</span>
        </a>
      </div>
    </div>
  );
};

export default ContactInfo;
